import {ServiceDetails} from "./Details";
import {Attachments} from "./Attachments";
import {ServiceForms} from "./Forms";
import {Reviews} from "./Reviews";
export const tabs = [
  {
    name: "Service Details",
    component: ServiceDetails,
    isDefault: true,
  },
  {
    name: "Attachments",
    component: Attachments,
    isDefault: true,
  },
  {
    name: "Forms",
    component: ServiceForms,
    isDefault: true,
  },
  {
    name: "Reviews",
    component: Reviews,
  },
];
export const defaultTab = tabs.find((tab) => tab.isDefault);
